import Ajax from '../util/Ajax';
import DomCreator from '../util/DomCreator';
import anime from 'animejs';
import { rand, randFloat } from '../functions';

export default class Form {
  constructor($form) {
    this.$form = $form;
    this.$sparkles = $form.classList.contains('js-sparkles');

    this.$button = this.$form.querySelector('.button');
    this.initialText = this.$button.getAttribute('value');
    this.text = this.$button.dataset.text;

    this.$form.addEventListener('submit', (e) => {
      e.preventDefault();
      this.onSubmit();
    });

    this.isSubmitted = false;
  }

  onSubmit() {
    if (this.isSubmitted) return;

    let data = new FormData(this.$form);
    data.append('action', 'submitForm');

    this.isSubmitted = true;

    const request = new Ajax(window.ajaxUrl, data);
    request.then((response) => {
      if (response.success) {
        if (this.$sparkles) {
          this.sparkles();
        }
        this.$form.reset();
      } else {
        this.displayError(response.error);
      }

      this.isSubmitted = false;
    });
  }

  sparkles() {
    if (this.$button.nodeName === 'INPUT') {
      this.$button.setAttribute('value', this.text);
      this.parent = this.$form;
      
      setTimeout(() => {
        this.$button.setAttribute('value', this.initialText);
      }, 3000);  
    } else {
      this.$button.innerHTML = this.text;
      this.parent = this.$button;

      setTimeout(() => {
        this.$button.innerHTML = this.initialText;
      }, 3000);  
    }

    this.parent.style.position = 'relative';

    const rangeX = 80;
    const rangeY = [35, 45];

    let sparkles = [];
    let directions = [];
    let scales = [];

    for (let i = 0; i < 7; i++) {
      const sparkle = DomCreator.symbol('✨');
      if (this.$button.nodeName === 'INPUT') {
        sparkle.style.left =
          this.$button.getBoundingClientRect().left -
          this.parent.getBoundingClientRect().left +
          this.$button.offsetWidth / 2 +
          'px';
        sparkle.style.top =
          this.$button.getBoundingClientRect().top -
          this.parent.getBoundingClientRect().top +
          this.$button.offsetHeight / 4 +
          'px';
      }
      this.parent.appendChild(sparkle);

      let directionX = rand(-rangeX, rangeX);

      let directionY = rand(rangeY[0], rangeY[1]);
      if (Math.random() < 0.5) directionY *= -1;

      DomCreator.removeAfter(sparkle, randFloat(1, 2));

      sparkles.push(sparkle);
      directions.push([directionX, directionY]);
      scales.push(randFloat(1, 2));
    }

    let timeline = anime.timeline({
      easing: 'easeOutExpo',
    });

    timeline.add({
      targets: sparkles,
      translateX: (el, i) => [0, directions[i][0]],
      translateY: (el, i) => [0, directions[i][1]],
      scale: (el, i) => [0, scales[i]],
      duration: 800,
    });

    timeline.add({
      targets: sparkles,
      scale: (el, i) => [scales[i], 0],
      duration: 400,
    });
  }

  displayError(text) {
    let div = document.createElement('div');
    div.classList.add('error-message');
    div.innerHTML = '❌ ' + text;
    div.style.top = this.$form.getBoundingClientRect().top;

    document.querySelector('.newsletter-form').appendChild(div);

    setTimeout(() => {
      div.remove();
    }, 3000);
  }
}



// WEBPACK FOOTER //
// ./scripts/dom/Form.js